export default class SynchronizedUtils {
  static dayDiff(firstDate, secondDate) {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
    return diffDays;
  }

  static conversionPercentage(fromDate, toDate, today) {
    const daysToTo = SynchronizedUtils.dayDiff(fromDate, toDate);
    const daysToToday = SynchronizedUtils.dayDiff(fromDate, today);
    const percentage = (daysToTo / daysToToday) * 100;
    return parseFloat(percentage.toFixed(2));
  }
}



// WEBPACK FOOTER //
// ./src/utils/synchronized.js